module.exports = __webpack_public_path__ + "static/media/service-bg.1a0ae75d.jpg";